import { Injectable } from '@angular/core';
import {
  CountryConfiguration,
  FALLBACK_DOCUMENT_MASK,
  FALLBACK_PHONE_MASK,
} from './country-configuration.model';
import { LATAM_COUNTRY_CONFIGS } from './latam-country-configs';
import { minLengthDocumentValidator } from '../validators/generic-document';
import { ValidatorFn } from '@angular/forms';
import { UNKNOWN_COUNTRY } from '../../services/language';

const FALLBACK_VALIDATOR: ValidatorFn = minLengthDocumentValidator(1);

@Injectable({ providedIn: 'root' })
export class CountryConfigurationService {
  private readonly configMap = new Map<string, CountryConfiguration>(
    LATAM_COUNTRY_CONFIGS.map((c) => [c.code, c]),
  );

  getConfig(countryCode: string | null): CountryConfiguration | null {
    if (!countryCode || countryCode === UNKNOWN_COUNTRY) return null;
    return this.configMap.get(countryCode) ?? null;
  }

  getPhoneMask(countryCode: string | null): string {
    return this.getConfig(countryCode)?.phoneMask ?? FALLBACK_PHONE_MASK;
  }

  getPhonePrefix(countryCode: string | null): string {
    return this.getConfig(countryCode)?.phonePrefix ?? '';
  }

  getPhonePlaceholder(countryCode: string | null): string {
    return this.getConfig(countryCode)?.phonePlaceholder ?? '';
  }

  getDocumentMask(countryCode: string | null): string {
    return this.getConfig(countryCode)?.documentMask ?? FALLBACK_DOCUMENT_MASK;
  }

  getDocumentType(countryCode: string | null): string {
    return this.getConfig(countryCode)?.documentType ?? '';
  }

  getDocumentPlaceholder(countryCode: string | null): string {
    return this.getConfig(countryCode)?.documentPlaceholder ?? '';
  }

  getDocumentValidator(countryCode: string | null): ValidatorFn {
    return this.getConfig(countryCode)?.documentValidator ?? FALLBACK_VALIDATOR;
  }
}
